import { getParam, setParam, removeParam } from '@/utils/Cookies';
import { removeParameterURL } from '@/utils/URL';
import { saveUser } from '@/utils/User';

// get app colors
export const getColors = () => {

    const lightColor = '#810000';
    const lightColorRGB = 'rgb(129,0,0)';
    const lightColorGradient = 'rgb(129,0,0,0.2)';

    const darkColor = '#FF0000';
    const darkColorRGB = 'rgb(255,0,0)';
    const darkColorGradient = 'rgb(255,0,0,0.2)';
  
  return {lightColor,lightColorRGB,lightColorGradient,darkColor,darkColorRGB,darkColorGradient};
}

// return regExp to check if /table/fullview/N
const fullViewRegExp = () => {

    //const regExp = new RegExp(`\/${table}\/view\/([0-9]+)`);
    const regExp = /\/([a-zA-Z-_]+)\/(fullview)\/([0-9]+)$/

    return regExp;
}

// to check if company sent by url to go to a concrete database
export const checkCompany = (router,user,setUser,handleLogin) => {
    
    var company = router.searchParams.get('company');

    // if any company, change the user company if user has permissions on it    
    if(company){

        const companyInt = parseInt(company);
        const companies = user?.companies;

        if(Object?.hasOwn(companies,companyInt)){
            
            user.company = companyInt;
            setUser(user);
            saveUser(user);

            // remove from url
            const path = removeParameterURL(router.pathname,router.searchParams,'company');
            router?.navigate(path);
        }
        else{
            handleLogin();
        }
    }

    return company;
}

// to hide menu/top bar on the page and show only content
export const checkFullPage = (searchParams) => {

    /*
        2 options:
        full page because the app is embedded on another one, so full page always => fullPage
        full page because on item details (for example) but the app should keep with the menu => fullView
    */

    var result = false;

    // check app on full page

    // values 0/1
    const fullPage = searchParams.get('fullPage');

    // if full page specified
    let valueInt;
    if(fullPage !== null){
        
        valueInt = parseInt(fullPage) ? 1 : 0;        
        result = valueInt ? true : false;

        // save full page on the cookies to keep app on full page        
        setParam('fullPage',valueInt ? 1 : 0);
    }
    else{
        // check if on cookies        
        const fullPageValue = getParam('fullPage');

        if(fullPageValue !== null){
            result = fullPageValue ? true : false;
        }
    }

    // if not app on full page, check view on full page  
    // options are use ?fullView=0/1 or url with xxx/fullview/N  
    if(!result){

        const regExp = fullViewRegExp();
        if(regExp.test(window.location.pathname)){
            result = true;
        }
        else{
            // values 0/1
            const fullView = searchParams.get('fullView');

            // if full view specified
            if(fullView !== null){
                
                valueInt = parseInt(fullView) ? 1 : 0;        
                result = valueInt ? true : false;

                // save full page on the cookies to keep app on full page        
                setParam('fullView',valueInt ? 1 : 0);
            }
            else{
                // 0 open url
                // 1 reload
                // 2 navigate with backward/forward
                
                // this only keeps if refreshing page because we only want it for the current view
                if(window?.performance?.navigation?.type === 1){

                    // check if on cookies        
                    const fullViewValue = getParam('fullView');

                    if(fullViewValue !== null){
                        result = fullViewValue ? true : false;
                    }
                }
                else{
                    // if not reloading
                    removeParam('fullView');
                }
            }
        }
    }

    return result;
}

export const getDarkMode = () => {
    
    //const darkmode = parseInt(getParam("darkmode"));
    const darkmode = getParam("darkmode");

    // if not null and 1, return true
    if(darkmode === 1 || darkmode === '1'){
        return true;
    }
    else{
        return false;
    }
}

export const setDarkMode = (darkmode) => {

    // change boolean to int
    if(darkmode){
        darkmode = 1;
    }
    else{
        darkmode = 0;
    }

    setParam("darkmode",darkmode);
}